import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useLang } from "../../context/LangContext";
import SubPageShell from "../../components/SubPageShell";

export default function Quotes() {
  const { user } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [rfqs, setRfqs] = useState(null);

  useEffect(() => {
    if (user === undefined) return;
    if (!user) { navigate("/login?next=/account/quotes"); return; }
    api("/rfq/mine", { auth: true }).then(setRfqs).catch(() => setRfqs([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!user) return null;

  return (
    <SubPageShell title={t("tab_quotes")} tid="quotes-page">
      {rfqs === null ? (
        <p data-testid="quotes-loading" className="py-10 text-center text-sm text-slate-500">...</p>
      ) : rfqs.length === 0 ? (
        <div data-testid="quotes-empty" className="mt-6 rounded-2xl border border-dashed border-slate-300 py-12 text-center">
          <p className="font-heading font-semibold text-slate-800">{t("no_quotes")}</p>
          <p className="mt-1 text-sm text-slate-500">{t("no_quotes_sub")}</p>
        </div>
      ) : (
        <div className="space-y-3">
          {rfqs.map((r, i) => (
            <div key={r.id || i} data-testid={`quote-row-${r.id || i}`} className="flex items-center gap-3 rounded-2xl bg-white p-4 shadow-sm ring-1 ring-slate-100">
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-semibold text-slate-900">{r.product_name}</p>
                <p className="mt-0.5 text-xs text-slate-400">
                  {r.quantity} {r.unit || "pcs"}{r.created_at ? ` · ${new Date(r.created_at).toLocaleDateString()}` : ""}
                </p>
              </div>
              {r.status && (
                <span className="shrink-0 rounded-full bg-amber-100 px-2.5 py-0.5 text-[10px] font-bold capitalize text-amber-800">{r.status}</span>
              )}
            </div>
          ))}
        </div>
      )}
    </SubPageShell>
  );
}
